import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { extractErrorMessage } from '../../../utils/apiResponseHandler';
import { Error } from '../../actions/error/error';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/blueprints/deployFoundation';

function* process(action) {
  try {
    const headers = getLocalUser();
    // The backend reads workspace from X-WORKSPACE-ID (mirrors model create).
    const workspaceId = action.payload?.workspace_id || localStorage.getItem('WORKSPACE_ID');
    if (workspaceId) {
      headers['X-WORKSPACE-ID'] = workspaceId;
    }

    const url = `${config.API_URL}/models/deploy-foundation`;
    const body = {
      blueprint_uid: action.payload?.blueprint_uid,
      horizon:       action.payload?.horizon,
      reason:        action.payload?.reason,
    };

    const response = yield call(axios.post, url, body, { headers });
    yield put(fetchSuccess(response.data?.data || response.data));
  } catch (error) {
    yield put(Error(error));
    yield put(fetchFailure(extractErrorMessage(error)));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, process);
}
